var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Form',{attrs:{"label-width":80}},[_c('FormItem',{attrs:{"label":"日期"}},[_c('DatePicker',{attrs:{"type":"daterange","placeholder":"请选择开始日期——结束日期"},on:{"on-change":_vm.changedate}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }